import { t } from "i18next";
import { DataTableData, DataTableHeader } from "../../../../../components/deprecated/DataTable/DataTable";

import { Utilities } from "../../../../../utils/utilities";
import { StringUtilities } from "../../../../../utils/stringUtilities";
import { CompanyData } from "../../../Company/CompanyData";
import { DataObjectHelper } from "../../DataObjects/DataObjectHelper";
import { LocalData } from "../../LocalData";
import { FirebaseDataCompanyField } from "../../DataObjectField/CustomFields/FirebaseDataCompanyField";
import { FirebaseDataPropertyField } from "../../DataObjectField/CustomFields/FirebaseDataPropertyField";
import { FirebaseDataDateField } from "../../DataObjectField/Generic/FirebaseDataDateField";
import { FirebaseDataStringField } from "../../DataObjectField/Generic/FirebaseDataStringField";

export class CompanyDataHelper extends DataObjectHelper<CompanyData> {
  id = () => "company";

  displayName = () => t("main.company");

  name = new FirebaseDataStringField<CompanyData>("name", t("main.name"), (company) => company.name, "abc");
  organizationId = new FirebaseDataStringField<CompanyData>(
    "organizationId",
    t("main.organizationId"),
    (company) => company.organizationId,
    "numbers"
  );
  properties = new FirebaseDataPropertyField<CompanyData>("properties", t("main.properties"), (company) => company.properties, "apartment", true);
  licence = new FirebaseDataStringField<CompanyData>("licence", t("main.license"), (company) => company.license, "fact_check");
  administrating = new FirebaseDataCompanyField<CompanyData>(
    "administrating",
    t("main.administrate"),
    (company) => company.administrating,
    "groups",
    true
  );
  administratedBy = new FirebaseDataCompanyField<CompanyData>(
    "administratedBy",
    t("main.administratedBy"),
    (company) => company.administratedBy,
    "supervisor_account",
    true
  );
  trialEnd = new FirebaseDataDateField<CompanyData>("trialEnd", t("main.trialEndsIn"), (company) => company.trialEnd, "free_cancellation");

  override getAllDatas(): CompanyData[] {
    return LocalData.currentUser.companies;
  }

  loadAll(): Promise<any> {
    const allPromises: Promise<any>[] = [];
    for (const company of LocalData.currentUser.companies) {
      const promise = company.load();
      allPromises.push(promise);
    }
    return Promise.all(allPromises);
  }

  allFields() {
    return [this.name, this.organizationId, this.properties, this.licence, this.administrating, this.administratedBy, this.trialEnd];
  }

  getAllDataTableDatas(documents: CompanyData[]): DataTableData[] {
    return documents.map((company) => {
      return {
        key: company.id,
        cells: {
          name: company.name,
          organizationId: company.organizationId,
          license: company.license === "trial" ? t("main.trial") : company.license === "administrated" ? t("main.customer") : t("main.company"),
          administratedBy:
            company.administratedBy.length === 0
              ? t("main.none")
              : StringUtilities.createString(
                  company.administratedBy.map((company) => company.name),
                  3
                ),
        },
      };
    });
  }
  getAllDataTableHeaders(): DataTableHeader[] {
    return [
      {
        key: "name",
        title: t("main.name"),
      },
      {
        key: "organizationId",
        title: t("main.organizationId"),
      },
      {
        key: "license",
        title: t("main.license"),
      },
      {
        key: "administratedBy",
        title: t("main.administratedBy"),
      },
    ];
  }
}

